import { InputLabel } from "@material-ui/core";

export default InputLabel;
